module.exports = __webpack_public_path__ + "static/media/back-seguro-celular-2.d4b69796.jpg";